import { EventDetailContent } from "@/app/event-detail/event-detail-content";
import { EventViewModel } from "@/event-core/types";
import { useSearchParams } from "next/navigation";

export default function Detail( { data }: { data: EventViewModel } ) {
    const searchParams = useSearchParams();
    const eventNo = searchParams.get( "eventno" );
    const comment = searchParams.get( "comment" );
    const guessNoFromUrl = searchParams.get( "guessno" );
    return (
        <div className="flex flex-col flex-1 min-h-0 h-full relative scale-100">
            <EventDetailContent
                eventData={data.eventData}
                guessList={data.guessList}
                isSingleGuessDetailPage={false}
                urlParams={{
                    eventNo: eventNo || "",
                    guessNo: guessNoFromUrl,
                    comment,
                }}
            />
        </div>
    );
}
